import React from 'react';
import { Bot, Sparkles, Settings, Wrench } from 'lucide-react';

interface GekkoAvatarProps {
  gekkoName: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function GekkoAvatar({ gekkoName, size = 'md' }: GekkoAvatarProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  const iconClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const getGekkoStyle = () => {
    switch (gekkoName) {
      case 'Kari':
        return {
          bgColor: 'bg-purple-100',
          iconColor: 'text-purple-500',
          icon: <Bot className={`${iconClasses[size]} animate-bounce`} />
        };
      case 'Kaizen':
        return {
          bgColor: 'bg-blue-100',
          iconColor: 'text-blue-500',
          icon: <Sparkles className={`${iconClasses[size]} animate-spin-slow`} />
        };
      case 'Ninja':
        return {
          bgColor: 'bg-emerald-100',
          iconColor: 'text-emerald-500',
          icon: <Settings className={`${iconClasses[size]} animate-spin-slow`} />
        };
      case 'Seisaku':
        return {
          bgColor: 'bg-amber-100',
          iconColor: 'text-amber-500',
          icon: <Wrench className={`${iconClasses[size]} animate-pulse`} />
        };
      default:
        return {
          bgColor: 'bg-blue-100',
          iconColor: 'text-blue-500',
          icon: <Bot className={iconClasses[size]} />
        };
    }
  };

  const style = getGekkoStyle();

  return (
    <div className={`${sizeClasses[size]} ${style.bgColor} rounded-full flex items-center justify-center ${style.iconColor}`}>
      {style.icon}
    </div>
  );
}